import { render, staticRenderFns } from "./RootCategoryCreate.vue?vue&type=template&id=69ea78fa&scoped=true&"
import script from "./RootCategoryCreate.vue?vue&type=script&lang=js&"
export * from "./RootCategoryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ea78fa",
  null
  
)

export default component.exports